import { MutationHookOptions, useMutation } from '@apollo/client';

import { useApolloClientForAspirex } from '@frontend/applications/AffiliatesApp/hooks/useApolloClientForAspirex';
import { CREATE_AUTOMATION_MUTATION } from '@frontend/app/queries';
import { CreateAutomation, CreateAutomationVariables } from '@frontend/app/queries/types/CreateAutomation';

type IOptions = MutationHookOptions<CreateAutomation, CreateAutomationVariables>;

export const useCreateAutomationMutation = (options: IOptions = {}) => {
  const client = useApolloClientForAspirex();

  return useMutation<CreateAutomation, CreateAutomationVariables>(CREATE_AUTOMATION_MUTATION, {
    ...options,
    client,
  });
};
